<template>
    <div class="container" v-loading="loading">
        <div class="title">
            <span>最新岗位</span>
            <span class="more pointer" @click="moreClick">更多</span>
        </div>
        <div class="post-list">
            <div class="post" v-for="post of postList" :key="post.postId">
                <div class="pointer" @click="postDetailClick(post.postId)"><span class="urgent" v-if="post.urgentFlag === 1">急</span>{{post.postName}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import requests from '@/utils/requests';
export default {
    name: 'NewestPost',
    props: {
        channelType: {
            type: [Number, String],
            default: ''
        }
    },
    watch: {
        channelType: {
            handler(value) {
                if (!value) {
                    return;
                }
                this.getNewPostList(value);
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            loading: false,
            postList: []
        };
    },
    created() {
        if (!this.$store.state.currentType) {
            return;
        }
        this.getNewPostList(this.$store.state.currentType);
    },
    methods: {
        // 根据类型获取最新岗位
        getNewPostList(type) {
            if (this.$store.state.newestPostList[type]) {
                this.postList = this.$store.state.newestPostList[type];
            } else {
                this.loading = true;
                requests.job.getPostListByParams(10, 1, type).then(v => {
                    this.postList = v.data;
                    const array = [];
                    for (const item of v.data) {
                        array.push({ postId: item.postId, postName: item.postName, urgentFlag: item.urgentFlag });
                    }
                    const list = this.$store.state.newestPostList;
                    list[type] = array;
                    this.$store.commit('saveNewestPost', list);
                    this.loading = false;
                });
            }
        },
        // 更多点击
        moreClick() {
            let url = '';
            if (this.$store.state.pageType) {
                url = '/' + this.$store.state.pageType + '/job';
            } else {
                url = '/job/' + (this.channelType === 1 ? 'social' : this.channelType === 2 ? 'campus' : 'worker');
            }
            console.log(url);
            if (url === this.$route.path) {
                this.$emit('change');
            } else {
                this.$router.push(url);
            }
        },
        // 岗位点击
        postDetailClick(id) {
            if (this.$route.path === '/post/' + id) {
                return;
            }
            this.$router.push('/post/' + id);
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #fff;
    padding: 0 20px;
}
.title {
    font-size: 16px;
    line-height: 60px;
    color: #090a0b;
    .more {
        float: right;
        line-height: 60px;
        font-size: 12px;
        color: #9a9fac;
    }
}
.post-list {
    .post {
        padding: 16px 23px 16px 0px;
        line-height: 20px;
        color: #5c6170;
        border-bottom: 0.5px dashed #eee;
    }
    .post:last-child {
        border-bottom: none;
    }
}
</style>
